export const TAB_COLOR = Styles.color.tertiary;
export const TAB_LINK_ACTIVE_BORDER_BOTTOM = `2px solid ${Styles.color.primary}`;
export const TAB_LINK_BORDER_BOTTOM = '2px solid transparent';
export const TAB_LINK_FOCUS_BORDER_BOTTOM = `3px solid ${Styles.color.primary}`;
export const WRAPPER_BACKGROUND = 'none';
export const WRAPPER_BORDER_BOTTOM = 'none';
export const WRAPPER_BOX_SHADOW = `0 2px 2px ${Styles.color.grey.five}`;
export const WRAPPER_MARGIN = '10px';
